/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Modal,
  Form,
  Input,
  Select,
  Row,
  Col,
  Button,
  DatePicker,
  notification,
} from 'antd'
import cnchar from 'cnchar'
import moment from 'moment'
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../app/store'
import {
  getMaterialsCategoryName,
  MaterialsCategories,
} from '../../models/commodity'
import { DateTimeFormat } from '../../models/datetime'
import {
  getSupplierCategory,
  SupplierCategories,
} from '../../models/supplierCategory'
import { isSameName } from '../../utils/fieldsUtils'
import styles from './supplier.module.css'
import {
  detailSupplier,
  selectDetail,
  selectId,
  setDetail,
  setSelectId,
  submitSupplierAsync,
} from './supplierSlice'
import { pinyin } from 'pinyin-pro'
import { CloseOutlined, PlusOutlined } from '@ant-design/icons'
import { UploadModal } from '../putstorelist/Query/uploadModal'
import {
  deleteUploadFileList,
  getUrl,
  isImage,
} from '../treatment/diagnosis/diagnosisSlice'
import { RcFile, UploadFile } from 'antd/lib/upload/interface'
import FileUpload from '../../compnents/file/FileUpload'
import ImagePreview from '../treatment/diagnosis/ImagePreview'
const { Option } = Select

export const SupplierModal = (props: {
  imgList?: any
  id?: any
  visible: boolean
  onOk: (supplierCategory?: any) => void
  onCancel: () => void
  supplierCategory?: number
}) => {
  const inputRef = useRef<Input>(null)
  
  const [action, setAction] = useState('新增')

  const [title, setTitle] = useState('供应商')

  const [state, setState] = useState(false)

  const dispatch = useDispatch<RootDispatch>()

  const detail: any = useSelector(selectDetail)

  const [form] = Form.useForm()

  const targetId = useSelector(selectId)

  const [lookPic, setLookPic] = useState('')

  const [isUploadVisible, setIsUploadVisible] = useState(false) //上传附件弹窗

  const [isLookPicModalVisible, setIsLookPicModalVisible] = useState(false)

  const [fileList, setFileList] = useState<UploadFile[]>([])

  const [isImageOrFile, setIsImageOrFile] = useState(false)

  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  }

  useEffect(() => {
    if (props.visible) {
      if (targetId) {
        setAction('修改')
        setState(true)
        dispatch(detailSupplier(targetId))
      } else {
        setAction('新增')
        setState(false)
      }
    }
  }, [targetId, props.visible])

  useEffect(() => {
    if (props.visible) {
      setFileList(props?.imgList)
      if (props.supplierCategory?.toString()) {
        form.setFieldsValue({
          supplierCategory: Number(props.supplierCategory),
        })
        setState(true)
      } else {
        return
      } 
    } else {
      setFileList([])
    }
    return () => {
      setState(false)
    }
  }, [props.visible, props.supplierCategory])

  useEffect(() => {
    if (JSON.stringify(detail) !== '{}') {
      form.setFieldsValue({
        ...detail,
        address: detail.address,
        companyName: detail.companyName,
        companyCode: detail.companyCode,
        createTime: detail.createTime,
        fax: detail.fax,
        licenceCategory: detail.licenceCategory,
        gspGmpDeadline: detail.gspGmpDeadline
          ? moment(detail.gspGmpDeadline)
          : null,
        taxDeadline: detail.taxDeadline
          ? moment(detail.taxDeadline)
          : null,
        licenceDeadline: detail.licenceDeadline
          ? moment(detail.licenceDeadline)
          : null,
        legalAuthDeadline: detail.legalAuthDeadline
          ? moment(detail.legalAuthDeadline)
          : null,
        licenceNumber: detail.licenceNumber,
        mnemonicCode: detail.mnemonicCode,
        phone: detail.phone,
        supplierMaterialsCategory: detail.supplierMaterialsCategory
          ? JSON.parse(detail.supplierMaterialsCategory)
          : undefined,
        postCode: detail.postCode,
        updateTime: detail.updateTime,
        supplierCategory: detail.supplierCategory,

      })
    }
  }, [detail])

    useEffect(() => {
    if (props.visible && !targetId) {
      // 添加一个小延迟，确保DOM元素已经完全渲染后再调用focus
      setTimeout(() => {
        inputRef.current?.focus()
      }, 100)
    }
  }, [props.visible, targetId])

  return (
    <>
      <Modal
        title={action + title}
        visible={props.visible}
        okText='确认'
        cancelText='取消'
        className={styles.form}
        maskClosable={false}
        onOk={() => {
          setState(false)
          dispatch(setSelectId(0))
          dispatch(setDetail({}))
          setAction('新增')
          form.resetFields()
          props.onOk()
        }}
        onCancel={() => {
          setState(false)
          setAction('新增')
          dispatch(setDetail({}))
          dispatch(setSelectId(0))
          form.resetFields()
          props.onCancel()
        }}
        footer={null}
      >
        <Form
          autoComplete='off'
          form={form}
          onFinish={(vs) => {
            const date = moment(vs.licenceDeadline)
            const gspdate = moment(vs.gspGmpDeadline)
            const taxdate = moment(vs.taxDeadline)
            const legaldate = moment(vs.legalAuthDeadline)

            if (targetId) {
              dispatch(
                submitSupplierAsync({
                  ...vs,
                  id: targetId,
                  licenceDeadline: vs.licenceDeadline
                    ? date.format(DateTimeFormat)
                    : null,
                  gspGmpDeadline: vs.gspGmpDeadline
                    ? gspdate.format(DateTimeFormat)
                    : null,
                  taxDeadline: vs.taxDeadline
                    ? taxdate.format(DateTimeFormat)
                    : null,
                  legalAuthDeadline: vs.legalAuthDeadline
                    ? legaldate.format(DateTimeFormat)
                    : null,
                  address: vs.address ? vs.address : undefined,
                  supplierMaterialsCategory: JSON.stringify(
                    vs.supplierMaterialsCategory
                  ),
                  fileUrl: fileList
                    ?.map((v) => `${v.name}@${v.uid}@`.concat(v.url || ''))
                    .join(','),
                })
              )
                .then(unwrapResult)
                .then(() => {
                  form.resetFields()
                  props.onOk(vs?.companyName)
                  dispatch(setDetail({}))
                  dispatch(setSelectId(0))
                })
            } else {
              dispatch(
                submitSupplierAsync({
                  ...vs,
                  licenceDeadline: vs.licenceDeadline
                    ? date.format(DateTimeFormat)
                    : null,
                  gspGmpDeadline: vs.gspGmpDeadline
                    ? gspdate.format(DateTimeFormat)
                    : null,
                  taxDeadline: vs.taxDeadline
                    ? taxdate.format(DateTimeFormat)
                    : null,
                  legalAuthDeadline: vs.legalAuthDeadline
                    ? legaldate.format(DateTimeFormat)
                    : null,
                  address: vs.address ? vs.address : undefined,
                  supplierMaterialsCategory: JSON.stringify(
                    vs.supplierMaterialsCategory
                  ),
                  fileUrl: fileList
                    ?.map((v) => `${v.name}@${v.uid}@`.concat(v.url || ''))
                    .join(','),
                })
              )
                .then(unwrapResult)
                .then(() => {
                  form.resetFields()
                  props.onOk(vs?.companyName)
                  dispatch(setDetail({}))
                  dispatch(setSelectId(0))
                })
            }
          }}
          name='advanced_search'
          className='ant-advanced-search-form'
          {...layout}
        >
          <Row>
            <Col span={8} style={{ textAlign: 'right' }}>
              <Form.Item
                label='供应商名称'
                name='companyName'
                rules={[
                  { required: true, message: '请输入供应商名称!' },
                  {
                    max: 45,
                    message: '最长45位',
                  },
                ]}
              >
                <Input
                  ref={inputRef}
                  onInput={(e: any) => {
                    form.setFieldsValue({
                      mnemonicCode: e.target.value
                        ? pinyin(e.target.value, {
                            pattern: 'first',
                            toneType: 'none',
                            separator: '',
                          }).toUpperCase()
                        : '',
                    })
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ textAlign: 'right' }}>
              <Form.Item
                label='供应类别'
                name='supplierCategory'
                rules={[{ required: true, message: '请输入供应商类别!' }]}
              >
                <Select placeholder='供应类别' disabled={props.supplierCategory !== undefined && props.supplierCategory !== null}>
                  <Option value={0}>供应商</Option>
                  <Option value={1}>生产厂商</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={8} style={{ textAlign: 'right' }}>
              <Form.Item label='自定义编号' name='companyCode'>
                <Input />
              </Form.Item>
            </Col>
            <Col span={8} style={{ textAlign: 'right' }}>
              <Form.Item
                label='助记码'
                name='mnemonicCode'
                rules={[
                  { required: true, message: '请输入助记码!' },
                  {
                    max: 45,
                    message: '最长45位',
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={8} style={{ textAlign: 'right' }}>
              <Form.Item
                label='地址'
                name='address'
                rules={[
                  {
                    max: 45,
                    message: '最长45位',
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={8} style={{ textAlign: 'right' }}>
              <Form.Item
                label='业务员'
                name='concatName'
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={8} style={{ textAlign: 'right' }}>
              <Form.Item
                label='电话'
                name='phone'
                rules={[
                  {
                    max: 45,
                    message: '最长45位',
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={8} style={{ textAlign: 'right' }}>
              <Form.Item
                label='传真'
                name='fax'
                rules={[
                  {
                    max: 45,
                    message: '最长45位',
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={8} style={{ textAlign: 'right' }}>
              <Form.Item
                label='邮编'
                name='postCode'
                rules={[
                  {
                    max: 45,
                    message: '最长45位',
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={8} style={{ textAlign: 'right' }}>
              <Form.Item
                label='供应物资类别'
                name='supplierMaterialsCategory'
                rules={[{ required: true, message: '请输入供应物资类别!' }]}
              >
                <Select allowClear mode='multiple'>
                  {MaterialsCategories.map((v) => (
                    <Option value={v} key={v}>
                      {getMaterialsCategoryName(v)}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8} style={{ textAlign: 'right' }}>
              <Form.Item
                label='企业信用代码'
                name='supplierTaxNo'
                rules={[
                  // { required: true, message: "请输入许可证号码!" },
                  {
                    max: 45,
                    message: '最长45位',
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={8} style={{ textAlign: 'right' }}>
              <Form.Item
                label='营业执照有效期'
                name='taxDeadline'
                // rules={[{ required: true, message: "请输入许可证有效期!" }]}
              >
                <DatePicker style={{ width: '100%' }} />
              </Form.Item>
            </Col>
            <Col span={8} style={{ textAlign: 'right' }}>
              <Form.Item
                label='许可证类型'
                name='licenceCategory'
                rules={[
                  // { required: true, message: "请输入许可证类型!" },
                  {
                    max: 45,
                    message: '最长45位',
                  },
                ]}
              >
                <Select>
                  {SupplierCategories.map((v) => (
                    <Option value={v} key={v}>
                      {getSupplierCategory(v)}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8} style={{ textAlign: 'right' }}>
              <Form.Item
                label='许可证号码'
                name='licenceNumber'
                rules={[
                  // { required: true, message: "请输入许可证号码!" },
                  {
                    max: 45,
                    message: '最长45位',
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={8} style={{ textAlign: 'right' }}>
              <Form.Item
                label='许可证有效期'
                name='licenceDeadline'
                // rules={[{ required: true, message: "请输入许可证有效期!" }]}
              >
                <DatePicker style={{ width: '100%' }} />
              </Form.Item>
            </Col>

            <Col span={8} style={{ textAlign: 'right' }}>
              <Form.Item
                label='GSP/GMP证书号码'
                name='gspGmpNumber'
                rules={[
                  // { required: true, message: "请输入许可证号码!" },
                  {
                    max: 45,
                    message: '最长45位',
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={8} style={{ textAlign: 'right' }}>
              <Form.Item
                label='GSP/GMP证书有效期'
                name='gspGmpDeadline'
                // rules={[{ required: true, message: "请输入许可证有效期!" }]}
              >
                <DatePicker style={{ width: '100%' }} />
              </Form.Item>
            </Col>
            <Col span={8} style={{ textAlign: 'right' }}>
              <Form.Item
                label='法人委托书有效期'
                name='legalAuthDeadline'
              >
                <DatePicker style={{ width: '100%' }} />
              </Form.Item>
            </Col>
            <Col span={8} style={{ textAlign: 'right' }}>
              <Form.Item
                label='开户银行'
                name='bankName'
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={8} style={{ textAlign: 'right' }}>
              <Form.Item
                label='开户行户名'
                name='accountName'
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={8} style={{ textAlign: 'right' }}>
              <Form.Item
                label='银行账号'
                name='accountNo'
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={8} style={{ textAlign: 'left' }}>
              <Form.Item label='上传附件' name=''>
                <FileUpload
                  count={fileList?.length || 0}
                  files={fileList}
                  onUpload={(v, i) => {
                    setFileList([
                      ...fileList,
                      {
                        uid: v.uid,
                        size: v.size,
                        name: v.name,
                        type: v.type,
                        originFileObj: {} as RcFile,
                        url: i,
                      },
                    ])
                  }}
                >
                  {/* <Button icon={<PlusOutlined />}>上传附件</Button> */}
                </FileUpload>
                <Button
                  icon={<PlusOutlined />}
                  onClick={() => {
                    setIsUploadVisible(true)
                  }}
                >
                  上传附件
                </Button>
                {fileList?.map((item: any) => (
                  <Row
                    gutter={24}
                    key={item.uid}
                    style={{
                      padding: '10px',
                      width: '300px',
                    }}
                  >
                    <Col flex={1}>
                      <span
                        style={{
                          display: 'inline-block',
                          maxWidth: '60px',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          verticalAlign: 'middle',
                        }}
                      >
                        {item?.name?.split('.')[0]}
                      </span>
                      <span
                        style={{
                          verticalAlign: 'middle',
                        }}
                      >
                        .{item?.name?.split('.')[1]}
                      </span>
                    </Col>
                    <Col span={6}>
                      <a
                        onClick={() => {
                          if (isImage(item.name)) {
                            setIsImageOrFile(true)
                          } else {
                            setIsImageOrFile(false)
                          }
                          dispatch(getUrl({ fileName: item.url }))
                            .then(unwrapResult)
                            .then((v: any) => {
                              const proxy =
                                window.location.origin.indexOf(
                                  'his.develop.hydhis.com'
                                ) >= 0
                                  ? '/proxyToOssDevPrivate'
                                  : window.location.origin.indexOf(
                                      'his.test.hydhis.com'
                                    ) >= 0
                                  ? '/proxyToOssTestPrivate'
                                  : window.location.origin.indexOf(
                                      'hydhis.cn'
                                    ) >= 0
                                  ? '/proxyToOssProdPrivate'
                                  : '/proxyToOssProdPrivate'
                              const url =
                                (window.location.origin?.includes('localhost')
                                  ? 'http://hydhis.cn'
                                  : window.location.origin) +
                                proxy +
                                v
                              setLookPic(url)
                              setIsLookPicModalVisible(true)
                              // window.open(
                              //   v.replace('http:', 'https:'),
                              //   '_blank'
                              // )
                            })
                        }}
                      >
                        查看
                      </a>
                    </Col>
                    <Col span={6}>
                      <CloseOutlined
                        onClick={() => {
                          //  e.stopPropagation();
                          setFileList(() =>
                            fileList?.filter((ite) => ite.uid !== item.uid)
                          )
                        }}
                      />
                    </Col>
                  </Row>
                ))}
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={20}>
            <Col span={12}>
              <Button
                type='primary'
                htmlType='submit'
                style={{ float: 'right' }}
              >
                确认
              </Button>
            </Col>
            <Col span={12}>
              <Button
                style={{ float: 'left' }}
                onClick={() => {
                  form.resetFields()
                  setState(false)
                  props.onCancel()
                }}
              >
                取消
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal>
      <UploadModal
        uploadModalVisible={isUploadVisible}
        accept={'.png,.tiff,.jpg,.jpeg,bmp,.heic,.webp'}
        id={props?.id}
        uploadType={1}
        onCancel={() => {
          setIsUploadVisible(false)
        }}
        maxCount={5}
        onSubmit={(v, i, id) => {
          if (fileList?.length + v.length > 5) {
            notification.info({
              message: '已达到最大上传数量，请先删除再上传！',
            })
            return
          }
          dispatch(deleteUploadFileList({ ids: id })).then(unwrapResult)
          setFileList(fileList?.length ? [...fileList, ...v] : v)
          setIsUploadVisible(false)
        }}
      />
      <ImagePreview 
        src={lookPic} 
        type={isImageOrFile} 
        visible={isLookPicModalVisible} 
        onClose={() => {
          setIsLookPicModalVisible(false)
          setLookPic('')
        }} 
      />
    </>
  )
}
